import axios from "../../assets/js/httpConfig/http";


/**
 * 获取列表
 * @param params
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function login(username, password) {
  return axios.post(`/admin/login?username=${username}&password=${password}`)
}


/**
 * 获取列表
 * @param params
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function getList(params) {
  return axios.get('/admin/sysUser/list', {params})
}

/**
 * 获取详细
 * @param id
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function getView(id) {
  return axios.get(`/admin/sysUser/view`, {
    params: {
      id
    }
  })
}

/**
 * 新建记录
 * @param data
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function createItem(data) {
  return axios.post('/admin/sysUser/add', data)
}

/**
 * 更新记录
 * @param id
 * @param data
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function updateItem(data) {
  return axios.put(`/admin/sysUser/edit`, data)
}

/**
 * 删除记录
 * @param id
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function deleteItem(id) {
  return axios.delete(`/admin/sysUser/delete/${id}`)
}

/**
 * 获取列表
 * @param params
 * @returns {Promise<AxiosResponse<unknown>>}
 */
export function getSelectData() {
  return axios.get('/admin/sysUser/getSelectData')
}



// WEBPACK FOOTER //
// ./src/api/user/index.js